import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import eomAnyZerosService from "../services/eom-any-zeroes-service";
import { selectRow } from "../state/reducers/eomSlice";
import { clearSelectedRow } from "../state/reducers/eomSlice";

const CreateAnyZeros = ({ history }) => {
  let { selectedRow } = useSelector(selectRow);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [parent, setParent] = useState(selectedRow?.payor || "");
  const [group, setGroup] = useState(selectedRow?.group || "");
  const [chargeCode, setChargeCode] = useState(selectedRow?.unique || "");
  const [rxf_number, setRXF] = useState(selectedRow?.rxf_number || "");
  const [seq_num, setSeq] = useState(selectedRow?.seq_num || "");
  const [price, setPrice] = useState(selectedRow?.price_code || "");
  const [qty, setQty] = useState(selectedRow?.qty || "");
  const [acq, setACQ] = useState(selectedRow?.acq || "");
  const [amount, setAmount] = useState(selectedRow?.amt_due || "");
  const { id } = useParams();

  useEffect(() => {
    if (id) getData(id);
  }, [id]);
  useEffect(() => {
    return function cleanup() {
      dispatch(clearSelectedRow());
    };
  }, []);

  const [error, setError] = useState(false);
  const [details, setdetails] = useState({});
  const getData = async () => {
    try {
      if (!id) return;
      setLoading(true);
      const resp = await eomAnyZerosService.getData(id);
      setdetails(resp);
      setParent(resp?.payor);
      setGroup(resp?.group);
      setChargeCode(resp?.unique);
      setRXF(resp?.rxf_number);
      setSeq(resp?.seq_num);
      setACQ(resp?.acq);
      setPrice(resp?.price_code);
      setQty(resp?.qty);
      setAmount(resp?.amt_due);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting  details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const onSubmit = async () => {
    try {
      if (!qty || !acq || !price?.length || !amount) {
        setError(true);
        return;
      }
      var data = {};
      data["price_code"] = price;
      data["qty"] = qty;
      data["acq"] = acq;
      data["amt_due"] = amount;

      if (details?.id) {
        data["id"] = details?.id;
        await eomAnyZerosService.updateData(data);
      } else {
        data["eom_id"] = selectedRow?.eom_id;
        data["group"] = selectedRow?.group;
        data["payor"] = selectedRow?.payor;
        data["unique"] = selectedRow?.unique;
        data["year"] = selectedRow?.year;
        data["month"] = selectedRow?.month;
        data["type"] = selectedRow?.type;
        data["rxf_number"] = selectedRow?.rxf_number;
        data["seq_num"] = selectedRow?.seq_num;

        await eomAnyZerosService.createData(data);
      }
      if (id) {
        await history.push("/anyZeros");
      } else {
        await history.push("/eom");
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{id ? "EDIT" : "CREATE"}</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Payor
              </label>
              <input
                id="payor"
                name="payor"
                type="text"
                disabled={true}
                placeholder="Payor"
                value={parent}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Group
              </label>
              <input
                id="group"
                name="group"
                type="text"
                disabled={true}
                placeholder="Payor"
                value={group}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Charge Code
              </label>
              <input
                id="unique"
                name="unique"
                type="text"
                disabled={true}
                placeholder="Charge Code"
                value={chargeCode}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                RXF Number
              </label>
              <input
                id="rxf_number"
                name="rxf_number"
                type="text"
                disabled={true}
                placeholder=" RXF Number"
                value={rxf_number}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Sequence Number
              </label>
              <input
                id="seq_num"
                name="seq_num"
                type="text"
                disabled={true}
                placeholder="Sequence Number"
                value={seq_num}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Quantity
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id="qty"
                name="qty"
                type="number"
                placeholder="Quantity"
                value={qty}
                onChange={(e) => setQty(e.target.value)}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && !qty && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify quantity
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Acquisition
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <input
                id="acq"
                name="acq"
                type="number"
                placeholder="Acquisition"
                value={acq}
                onChange={(e) => setACQ(e.target.value)}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
              {error && !acq && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify acquisition
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Price Code
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id="price"
                name="price"
                type="text"
                placeholder="Price Code"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
              {error && price?.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify price code
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Amount Due
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id="amt_due"
                name="amt_due"
                type="number"
                placeholder="Amount Due"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
              {error && amount?.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify amount due
                </p>
              )}
            </li>

            <li className="text-center">
              <button
                disabled={loading}
                onClick={() => onSubmit()}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CreateAnyZeros)
);
